// Explicit icon map: importing only what we use keeps the bundle small
// (`import * as Icons from 'lucide-react'` pulls in every icon in the library).
import {
  Anchor, Box, Boxes, Briefcase, Check, Container, FileCheck, FileText, Globe, Leaf,
  Package, PackageOpen, Route, ShieldCheck, Ship, TrainFront, Truck, Undo2, Warehouse,
} from 'lucide-react';

const iconMap = {
  Anchor, Box, Boxes, Briefcase, Check, Container, FileCheck, FileText, Globe, Leaf,
  Package, PackageOpen, Route, ShieldCheck, Ship, TrainFront, Truck, Undo2, Warehouse,
};

// mock.js refers to icons by name; unknown names fall back to `fallback`.
export const getIcon = (name, fallback = Check) => iconMap[name] || fallback;
